export default class LTVersion {
}
LTVersion.version = "0.0.1";
